export default {
  name: "EventCategoryGroupEdit",
  props: ["editedCategoryGroup"]
};
